/** @module csi/view/ToolbarFullScreen */
define([
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginButton"
], function(lang, Action, PluginFactory, ToolbarPluginButton) {

	return PluginFactory.declare("fullScreen", ToolbarPluginButton, {
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "ViewFullScreen"
			});
			this.defAction.setMaterialIcon("zoom_out_map");
			this.defAction.resolve();
		},

		/**
		 * @override
		 * Validate plugin can render in the view
		 */
		validatePlugin: function(ctx) {
			const {bInSwitchboard, bPopup} = ctx.view;
			return !bInSwitchboard && !bPopup;
		}
	});
});